module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"emailFormatInvalid":"Formato de e-mail inválido.","emailDomainInvalid":"E-mail com domínio inválido."},"en-US":{"emailFormatInvalid":"Invalid email format.","emailDomainInvalid":"Email with invalid domain."}}')
  delete Component.options._Ctor
}
